import React from 'react'
import { Outlet } from 'react-router-dom'

function LumpLayout() {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default LumpLayout
